import { emailService } from "../../services/api";

export async function sendEmail(email: string | undefined, text: string): Promise<boolean> {
    try {
      const response = await emailService.send({
        type: email ? "business" : "anonymous",
        text: text,
        email: email,
      });
      
      // Check if response is successful
      if (response && response.status == 200) {
        // console.log("Email sent successfully");
        return true;
      } else {
        console.error("Server returned an unsuccessful status code:", response?.status);
        return false;
      }
    } catch (error) {
      console.error("Error sending email:", error);
      return false;
    }
  }